import { defineStore } from 'pinia'

interface User {
  id: number
  username: string
  role: string
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as User | null,
    accessToken: null as string | null
  }),

  getters: {
    isAdmin(state): boolean {
      return state.user?.role === 'ADMIN'
    },

    isAuthenticated(state): boolean {
      return !!state.accessToken
    }
  },

  actions: {
    login(user: User, token: string) {
      this.user = user
      this.accessToken = token

      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('access_token', token)
    },

    logout() {
      this.user = null
      this.accessToken = null

      localStorage.removeItem('user')
      localStorage.removeItem('access_token')
    },

    init() {
      const storedUser = localStorage.getItem('user')
      const storedToken = localStorage.getItem('access_token')

      if (storedUser) {
        try {
          this.user = JSON.parse(storedUser)
        } catch (e) {
          localStorage.removeItem('user')
        }
      }

      if (storedToken) {
        this.accessToken = storedToken
      }
    }
  }
})
